import React, { PureComponent } from 'react';
import { Route } from 'react-router-dom';

import ProfileComponent from './profile-component';

class User extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (<div>
      <Route path="/profile/:id" component={ProfileComponent} />
    </div>);
  }
}

export default User;
